import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ContentCentreHero from "../../../../V2/Heroes/Content/CentreHero"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokContentCentreHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ContentCentreHero>) => {
  return (
    <ContentCentreHero
      primaryBackgroundColor={blok.backgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      primaryButtonBorderColor={blok.primaryCTAColor}
      bodyText={blok.bodyText}
      headingText={blok.headingText}
      subHeadingText={blok.subHeadingText}
      headingSize={blok.headingSize}
      headingMobileAlignment={blok.headingMobileAlignment}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      mobileImageUrl={blok.mobileImage?.filename}
      primaryButtonLink={storyblokLinkToYocoLink(blok.primaryCTALink)}
      primaryButtonMobileLink={storyblokLinkToYocoLink(
        blok.primaryCTAMobileLink
      )}
      primaryButtonText={blok.primaryCTAText}
      primaryButtonMobileText={blok.primaryCTAMobileText}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      secondaryButtonLink={storyblokLinkToYocoLink(blok.secondaryCTALink)}
      secondaryButtonText={blok.secondaryCTAText}
      videoUrl={
        blok.video?.filename ??
        storyblokLinkToYocoLink(blok.videoUrl)?.url ??
        ""
      }
      callout={blok.callout ? blok.callout[0] : undefined}
      hasScrollArrow={blok.hasScrollArrow}
      hideMobileStickyButton={blok.hideMobileStickyButton}
      secondaryTrackingEvent={blok.secondaryTrackingEvent}
      secondaryTrackingEventKey={blok.secondaryTrackingEventKey}
      secondaryTrackingEventValue={blok.secondaryTrackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokContentCentreHero
